module.exports = __webpack_public_path__ + "static/media/delete-job-button-white.412452ed.png";